import gql from 'graphql-tag';

export type GetFavoritesResponse = {
  userFavorites: {
    data: {
      attributes: { variantIds: number[] };
      id: string;
      type: string;
    };
  };
};

export const GET_FAVORITES_QUERY = gql`
  query GetFavoritesQuery {
    userFavorites @rest(type: "RestUserFavorites", endpoint: "user", path: "/likes") {
      data @type(name: "RestUserFavoritesData") {
        id
        type
        attributes @type(name: "UserFavoritesAttributes") {
          variantIds: variant_ids
        }
      }
    }
  }
`;

export const ADD_FAVORITE_MUTATION = gql`
  mutation AddFavoriteMutation($id: Int!) {
    addFavorite(id: $id, input: {})
    @rest(type: "RestUserFavorites", endpoint: "user", path: "/likes/{args.id}", method: "POST") {
      NoResponse
    }
  }
`;

export const REMOVE_FAVORITE_MUTATION = gql`
  mutation RemoveFavoriteMutation($id: Int!) {
    removeFavorite(id: $id)
    @rest(type: "RestUserFavorites", endpoint: "user", path: "/likes/{args.id}", method: "DELETE") {
      NoResponse
    }
  }
`;
